import { TAGS_KEY } from 'constants/utils';
import { Installation } from 'interfaces';
import { Tags } from 'interfaces/Tags';
import { ApiService } from 'services/Api';
import { AttendanceAttendantsResponse } from 'typings/services/AttendanceAttendant';
import { AttendanceQueue } from 'typings/services/AttendanceQueue';

export class GoPersonalService {
    private readonly packId: string | undefined;
    private readonly ApiService: ApiService;

    constructor(baseUrl: string | undefined, access_token: string | undefined, packId?: string) {
        this.packId = packId;
        this.ApiService = new ApiService(baseUrl ?? '', '', access_token);
    }

    async getInstallations() {
        return this.ApiService.get<Installation[]>(`v1/installations/pack/${this.packId}/authenticated-member`);
    }

    private static isTagsNotFound(error: any): boolean {
        return error?.response?.status === 424 && error?.response?.data?.statusCode?.includes('404');
    }

    async getTags(tenantId: string, botId: string): Promise<Tags> {
        try {
            return await this.ApiService.get<Tags>(`v1/Tenants/${tenantId}/Bots/${botId}/Buckets/desk/config?key=${TAGS_KEY}`);
        } catch (error: any) {
            if (GoPersonalService.isTagsNotFound(error)) {
                return { tags: [], hasTags: false, isTagsRequired: false };
            }
            throw error;
        }
    }

    async patchTickets(installationId: number, ticketId: string, body: { tags: string[] }) {
        return this.ApiService.patch(
            `v1/Attendance/Tickets/pack/${this.packId}/installation/${installationId}/${ticketId}/close`,
            body,
        );
    }

    async getQueuesWithAgentsOnline(tenantId: string, botId: string) {
        return this.ApiService.get<AttendanceQueue[]>(
            `v1/Tenants/${tenantId}/Bots/${botId}/Attendance/Queues/AgentsOnline`,
        );
    }

    async getAttendants(tenantId: string, botId: string) {
        return this.ApiService.get<AttendanceAttendantsResponse>(
            `v1/Tenants/${tenantId}/Bots/${botId}/Attendance/Attendants`,
        );
    }

    async transferTicket(
        installationId: number,
        ticketId: string,
        body: { attendantEmail?: string; team?: string },
    ): Promise<void> {
        await this.ApiService.post<void>(
            `v1/Attendance/Tickets/pack/${this.packId}/installation/${installationId}/${ticketId}/transfer`,
            body,
        );
    }
}
